import { render, staticRenderFns } from "./MealDetail.vue?vue&type=template&id=1d9ce514&scoped=true"
import script from "./MealDetail.vue?vue&type=script&lang=js"
export * from "./MealDetail.vue?vue&type=script&lang=js"
import style0 from "./MealDetail.vue?vue&type=style&index=0&id=1d9ce514&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9ce514",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d9ce514')) {
      api.createRecord('1d9ce514', component.options)
    } else {
      api.reload('1d9ce514', component.options)
    }
    module.hot.accept("./MealDetail.vue?vue&type=template&id=1d9ce514&scoped=true", function () {
      api.rerender('1d9ce514', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/mealOrder/MealDetail.vue"
export default component.exports